// combatpro/panels/SpellPanel.js
//
// Combat PRO - SpellPanel.
//
// Stage 8 extracted this as the static view-spells shell: a view container plus
// the empty #vi-spells-mount mount point, faithfully matching battletracker.html
// (the visible spell-card UI was NOT static there - vi_mountSpells relocated a
// runtime-generated spells-block node into the mount).
//
// Stage 48B-3 (Spell Workspace Integration) wires the completed SpellWorkspace
// into that mount so the finished Spell UI becomes reachable. This is integration
// only - no new runtime, no new behaviour, no styling.
//
// Legacy reference (vi_mountSpells, battletracker.html 10057 / view-open 11663):
// 16 hidden spells-block nodes were pre-generated, and opening the spells view
// reparented the ACTIVE monster's block into #vi-spells-mount and revealed it
// (display:block). The React-faithful equivalent - per the migration rule to
// replace getElementById/DOM relocation rather than port it - is to render the
// active monster's SpellWorkspace directly into the mount. There is no reparent
// and no unmount bookkeeping: switching the active monster re-renders the mount
// with the new index automatically. mounted={true} reproduces the legacy reveal.
//
// Handler wiring (verified against the uploaded CombatContext.js, not memory):
//   onRandomSpell    -> selectRandomSpell     (index, slot)
//   onSpellChange    -> updateSpell           (index, slot, spellName)
//   onCastRoundChange-> updateSpellCastRound  (index, slot, round)
//   onClearSpell     -> clearSpell            (index, slot)
// The two remaining interface props belong to Stage 50 (Custom Spell Studio) and
// have no migrated runtime, so per the Stage 48B-3 decision they are bare no-ops
// whose only purpose is to satisfy the component interface and prevent runtime
// errors - no dialogs, alerts, warnings, or substitute behaviour:
//   onAddSpell       -> noop
//   onEditSpell      -> noop
//
// No optional chaining. No em dash. Do not edit battletracker.html.

import React, { useContext } from 'react';
import { CombatContext } from '../contexts/CombatContext';
import SpellWorkspace from './spells/SpellWorkspace';

function SpellPanel(props) {
  const { state, selectRandomSpell, updateSpell, updateSpellCastRound, clearSpell } = useContext(CombatContext);
  const activeIndex = state.currentCombatantIndex;

  // Stage 52 / Stage 53 (Custom Spell Studio UI): the Add Spell button opens the
  // Spell Studio in create mode; the slot Edit button opens it in edit mode. Both
  // callbacks are threaded in from CombatProEngineView via ViewRoot. handleEditSpell
  // reproduces the legacy vi_editSpellFromSlot (battletracker.html 12679-12685):
  // resolve the slot's assigned spell name, look it up in the runtime spell DB
  // (window.VI_SPELLS_DB - the same source SpellSlot reads), and open the editor
  // with that spell. No-op when the slot is empty or the spell is not found.
  function noop() {}
  const onAddSpell = props.onAddSpell || noop;

  function handleEditSpell(index, spellIdx) {
    const monster = state.monsters[index];
    const slot = (monster && monster.spells) ? monster.spells[spellIdx] : null;
    const spellName = (slot && slot.name) ? slot.name : '';
    if (!spellName) { return; }
    const spellsDb = (typeof window !== 'undefined' && window.VI_SPELLS_DB) ? window.VI_SPELLS_DB : [];
    let found = null;
    for (let i = 0; i < spellsDb.length; i++) {
      if (spellsDb[i] && spellsDb[i].name === spellName) { found = spellsDb[i]; break; }
    }
    if (!found) { return; }
    if (props.onOpenSpellEditor) { props.onOpenSpellEditor(found); }
  }

  return (
    <div className="vi-view" id="view-spells">
      <div id="vi-spells-mount">
        <SpellWorkspace
          index={activeIndex}
          mounted={true}
          onRandomSpell={selectRandomSpell}
          onAddSpell={onAddSpell}
          onSpellChange={updateSpell}
          onCastRoundChange={updateSpellCastRound}
          onClearSpell={clearSpell}
          onEditSpell={handleEditSpell}
        />
      </div>
    </div>
  );
}

export default SpellPanel;
